export default __webpack_public_path__ + "static/media/Nayna Dhote.d1275c78.jpeg";